import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { sendMessage, prepareImage } from "actions/messages";
import { alertError } from "actions/ui";
import { logError, logDebug } from "actions/log";

class SoundInput extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			recording: false,
			time: 0
		};

		this.startRecording = this.startRecording.bind(this);
		this.stopRecording = this.stopRecording.bind(this);
		this.initMedia = this.initMedia.bind(this);
		this.timerCount = this.timerCount.bind(this);
		this.renderTimer = this.renderTimer.bind(this);
	}

	componentWillUnmount() {
		this.clearTimer();
	}

	initMedia(promise) {
		const constraints = {
			audio: true,
			video: false,
		};

		// must be initialized as a result of user's action:
		if (!this.audioContext) {
			this.audioContext = new AudioContext();
		}

		navigator.mediaDevices.getUserMedia(constraints).then((stream => {
			this.gumStream = stream;
			this.input = this.audioContext.createMediaStreamSource(stream);

			this.recorder = new WebAudioRecorder(this.input, {
				workerDir: this.props.configuration.baseDir + 'assets/js/libs/',
				encoding: 'mp3',
				onEncoderLoading: (recorder, encoding) => {
					this.props.logDebug('debug', "Loading " + encoding + " encoder...");
				},
				onEncoderLoaded: (recorder, encoding) => {
					this.props.logDebug('debug', encoding + " encoder loaded");
				}
			});

			this.recorder.onComplete = (recorder, blob) => {
				this.props.logDebug('debug', "Encoding complete", blob);
				this.props.onChange({ data: blob, type: this.recorder.encoding });
				this.props.onCompleteProcessing();
			}

			this.recorder.onTimeout = this.stopRecording;

			this.recorder.onError = (recorder, message) => {
				this.props.alertError('Audio recorder error: ' + message);
				this.props.logError('Audio recorder error', message);
				this.props.onCompleteProcessing();
			}

			this.recorder.setOptions({
				timeLimit: this.props.configuration.interface.input.sounds.maxLength,
				encodeAfterRecord: true,
				mp3: {
					bitRate: this.props.configuration.interface.input.sounds.mp3BitRate
				}
			});

			promise();
		})).catch(err => {
			this.props.alertError(this.props.i18n.noMicrophoneError);
			this.props.logError('Could not execute getUserMedia feature', err);
		});
	}

	startRecording(event) {
		event.preventDefault();

		this.initMedia(() => {
			this.recorder.startRecording();
			this.startTimer();
		});
	}

	stopRecording() {
		this.gumStream.getAudioTracks()[0].stop();
	    this.recorder.finishRecording();

		this.props.onStartProcessing();
		this.clearTimer();
	}

	timerCount() {
		this.setState({ time: this.state.time + 1 });
	}

	clearTimer() {
		this.setState({ recording: false, time: 0 });
		if (this.timer) {
			clearInterval(this.timer);
			delete this.timer;
		}
	}

	startTimer() {
		this.setState({ recording: true, time: 0 });
		this.timer = setInterval(this.timerCount, 1000);
	}

	renderTimer() {
		let minutes = Math.floor(this.state.time / 60);
		let seconds = this.state.time % 60;

		return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
	}

	render() {
		return(
			<React.Fragment>
				{ !this.state.recording && <button className="wcInputButton wcSoundAttachmentStart wcFunctional" onClick={ this.startRecording } /> }
				{ this.state.recording && <React.Fragment>
						<button className="wcInputButton wcSoundAttachmentStop wcFunctional" onClick={ this.stopRecording } />
						<span className="wcInputButtonSupplementary">{ this.renderTimer() }</span>
					</React.Fragment>
				}
			</React.Fragment>
		)
	}

}

SoundInput.propTypes = {
	channel: PropTypes.object.isRequired,
	configuration: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired,
	onStartProcessing: PropTypes.func.isRequired,
	onCompleteProcessing: PropTypes.func.isRequired
};

export default connect(
	state => ({
		configuration: state.configuration,
		i18n: state.application.i18n,
	}),
	{ sendMessage, prepareImage, alertError, logError, logDebug }
)(SoundInput);